module.exports = __webpack_public_path__ + "static/media/ploni-ultralight-aaa.9384cbb7.woff";